import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { ImUsers, ImUserPlus } from "react-icons/im";
import AccountsCreateForm from "pages/accounts/AccountsCreateForm";
import ProfileView from "pages/accounts/ProfileView";
import { createLocationAdminThunk } from "store/reducers/accounts";
import { useDispatch } from "react-redux";
function LocationAdminAccount() {
  const dispatch = useDispatch();
  const formCallback = (input) => {
    dispatch(createLocationAdminThunk(input));
  };
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Location admin"
        viewIcon={<ImUsers />}
        createIcon={<ImUserPlus />}
        createChildren={
          <AccountsCreateForm mod="Location admin" callback={formCallback} />
        }
        listChildren={<ProfileView mod="locationAdmin" />}
      />
    </Box>
  );
}

export default LocationAdminAccount;
